import type { NskResponse } from "~/models/Api";
import type { VendorManagementCompanySetting } from "~/models/VendorManagementCompanySetting";
import { putRequest } from "~/utils/api/api_handler";

const paths = {
	update: "/vendors/vendor_management_company_settings/:company_master_id"
};

export const update = async (
	companyMasterId: number,
	vendorManagementCompanySetting: VendorManagementCompanySetting
): Promise<NskResponse> =>
	putRequest(
		paths.update.replace(":company_master_id", String(companyMasterId)),
		{ vendorManagementCompanySetting }
	);
